import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function CSVFileIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Document shape with no fill, just outline */}
        <path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
          stroke="#4F4F4F" 
          strokeWidth="1.5"
          fill="none"
        />
        {/* Folded corner */}
        <path
          d="M14 2V8H20"
          stroke="#4F4F4F"
          strokeWidth="1.5"
          fill="none"
        />
        {/* CSV text */}
        <text
          x="12"
          y="16"
          fontFamily="Arial, sans-serif"
          fontSize="5"
          textAnchor="middle"
          fontWeight="bold"
          fill="#4F4F4F"
        >
          CSV
        </text>
      </svg>
    </SvgIcon>
  );
}